import * as React from 'react'
import PropTypes from 'prop-types'

import * as casino from '@rushplay/casino'

export function LiveCasinoQuery(props) {
  return <casino.LiveCasinoQuery mountPoint="casino" {...props} />
}

LiveCasinoQuery.propTypes = {
  clientType: PropTypes.string.isRequired,
}
